
import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-select',
    label: '分類',
    model: 'categories_id',
    required: true,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/about-us-categories-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '標題',
    model: 'title',
    placeholder: '標題',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "內文",
    model: "contents",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'number',
    label: '權重',
    model: 'weight',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  }
];

export default fields;
